import {NewMaterialDetailsCard} from './NewMaterialDetailsCard'

export const PageNewMaterialDetails: React.FC = () => {
  return <NewMaterialDetailsCard />
}
